import styled from "styled-components";

export const Wrapper = styled("div")(({ theme, $isShowInSmallScreen }) => ({
  ...($isShowInSmallScreen ? { display: "none" } : { display: "flex" }),
  flexDirection: "column",
  gap: 15,

  [theme.down("lg")]: {
    ...($isShowInSmallScreen ? { display: "flex" } : { display: "none" }),
  },
}));

export const RefundButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  gap: 8,
  border: `1px solid ${theme.palette.searchButtonBg}`,
  borderRadius: 4,
  backgroundColor: "transparent",
  color: theme.palette.searchButtonBg,
  fontSize: 18,
  fontWeight: 600,
  transition: "all .3s ease-out",
  height: 46,
  width: "100%",
  cursor: "pointer",

  "&:hover": {
    backgroundColor: theme.palette.searchButtonBg,
    color: theme.palette.white,
  },
}));
